import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

import Express from '../views/expressDes.vue'
import Quality from '../views/qualityDes.vue'
import Process from '../views/processDes.vue'
import Problem from '../views/problemDes.vue'
import Serve from '../views/serveDes.vue'
import Privacy from '../views/privacy.vue'
import Company from '../views/companyDes.vue'
Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/help',
    name: 'Help',
    component: () => import('../views/helpCenter.vue'),
		children: [
			{
				path: 'express',
				name: 'Express',
				component: Express
			},
			{
				path: 'process',
				name: 'Process',
				component: Process
			},
			{
				path: 'quality',
				name: 'Quality',
				component: Quality
			},
			{
				path: 'problem',
				name: 'Problem',
				component: Problem
			},
			{
				path: 'serve',
				name: 'Serve',
				component: Serve
			},
			{
				path: 'privacy',
				name: 'Privacy',
				component: Privacy
			},
			{
				path: 'company',
				name: 'Company',
				component: Company
			}
		]
  }
]

const router = new VueRouter({
  routes
})

export default router
